export const ttlockConfig = {
  credentials: {
    title: "Configurazione TTLock",
    subtitle: "Inserisci le credenziali del tuo account TTLock",
    savedBadge: "Credenziali salvate",
    noneBadge: "Nessuna credenziale",
    emailLabel: "L'email del tuo account TTLock",
    emailPlaceholder: "you@example.com",
    emailHelp: "L'email che usi per accedere a TTLock",
    passwordLabel: "Password",
    passwordPlaceholderSaved: "•••••••• (salvata, facoltativo modificarla)",
    passwordPlaceholder: "La tua password TTLock",
    passwordHelpSaved: "Puoi lasciarla vuota se ne hai già una salvata.",
    passwordHelp: "La password del tuo account TTLock.",
    testing: "Verifica in corso...",
    testConnection: "Verifica connessione",
    saving: "Salvataggio...",
    saveCredentials: "Salva credenziali",
  },
  selector: {
    title: "Selettore delle serrature per questa struttura",
    subtitleBefore: "Seleziona solo le serrature che riguardano ",
    subtitleStrong: "questa struttura",
    subtitleAfter: ".",
    selectedCount: "{count} selezionata | {count} selezionate",
    hintBefore: "Inserisci le tue credenziali e premi ",
    hintStrong: "Verifica connessione",
    hintAfter: " per caricare le tue serrature.",
    noneFound: "Nessuna serratura trovata. Controlla il tuo account TTLock.",
    placeholder: "Seleziona le serrature…",
    summaryCount: "{count} serratura selezionata | {count} serrature selezionate",
    emptySelection: "Nessuna serratura selezionata",
    saving: "Salvataggio...",
    save: "Salva le serrature per questa struttura",
  },
  gateway: {
    with: "Con Gateway",
    without: "Senza Gateway",
  },
  pms: {
    title: "Controllo e assegnazione (PMS)",
    subtitleP1: "Assegna ogni serratura a ",
    subtitleStrongMain: "Porta principale",
    subtitleP2: " oppure ",
    subtitleStrongUnit: "Unità",
    subtitleP3: ".",
    assignedCount: "{count} assegnata | {count} assegnate",
    empty: "Non hai ancora serrature salvate per questa struttura.",
    assignmentLabel: "Assegnazione",
    assignmentNone: "Non assegnata",
    assignmentCommon: "Porta principale (condivisa)",
    assignmentUnit: "Porta dell'appartamento",
    hintNone: "Non verrà controllata dal PMS.",
    hintAssigned: "Verrà collegata a questa struttura per il controllo e i PIN.",
    unitLabel: "Unità / Alloggio",
    unitSelectPlaceholder: "Seleziona un'unità",
    unitHint: "Seleziona quale unità apre questa serratura.",
    nameLabel: "Nome (facoltativo)",
    namePlaceholder: "es. Porta principale / App. 101",
    saving: "Salvataggio...",
    save: "Salva assegnazione",
  },
  actions: {
    lock: "Blocca",
    unlock: "Sblocca",
    requiresGateway: "Richiede Gateway",
    createPasscode: "Crea codice di accesso",
    passcodeHistory: "Cronologia codici di accesso",
    refreshStatus: "Aggiorna stato",
  },
  lockFallbackName: "Serratura {id}",
  unitFallbackName: "Unità {id}",
  history: {
    title: "Cronologia codici di accesso",
    revocationTitle: "Informazioni sulla revoca dei codici:",
    withGatewayLabel: "Con gateway:",
    withGatewayText: "Il codice viene revocato immediatamente sulla serratura fisica.",
    withoutGatewayLabel: "Senza gateway:",
    withoutGatewayText:
      "Il codice viene rimosso dal server TTLock, ma continuerà a funzionare sulla serratura finché qualcuno non si connette via Bluetooth dall'app mobile e sincronizza.",
    loading: "Caricamento cronologia…",
    empty: "Nessun codice di accesso registrato per questa serratura.",
    colAlias: "Alias",
    colPasscode: "Codice di accesso",
    colValidity: "Validità",
    colStatus: "Stato",
    createdAt: "Creato: {date}",
    fromLabel: "Dal:",
    toLabel: "Al:",
    revokedTitle: "Già revocato",
    revokeTitle: "Elimina / Revoca codice di accesso",
    close: "Chiudi",
  },
  passcodeModal: {
    title: "Crea codice di accesso temporaneo",
    nameLabel: "Nome / Etichetta",
    namePlaceholder: "es. Pulizie / Ospite / Tecnico",
    nameHint: "Questo nome ti aiuterà a identificare il codice.",
    validFrom: "Valido dal",
    validTo: "Valido fino al",
    importantLabel: "Importante:",
    importantText:
      "Il codice verrà generato automaticamente da TTLock e sarà disponibile solo durante il periodo specificato. L'ospite può inserire questo codice direttamente sul tastierino della serratura (funziona senza internet).",
    noGatewayLabel: "Senza Gateway:",
    noGatewayText:
      "Questa serratura non ha un gateway collegato. I codici generati funzioneranno perfettamente sul tastierino fisico, ma non potrai revocarli da remoto da questo pannello. Per revocarli, dovrai farlo dall'app TTLock connettendoti via Bluetooth.",
    cancel: "Annulla",
    creating: "Creazione...",
    create: "Crea codice di accesso",
  },
  states: {
    active: "Attivo",
    upcoming: "In arrivo",
    expired: "Scaduto",
    revoked: "Revocato",
    noDate: "Senza data",
  },
  confirm: {
    revoke:
      'Vuoi davvero revocare/eliminare il codice di accesso "{alias}"?\n\nNota: se la serratura non ha un gateway, la revoca potrebbe essere solo parziale.',
  },
  toast: {
    noLocksFound: "Nessuna serratura trovata in TTLock.",
    loadStatusError: "Impossibile caricare lo stato della serratura",
    loadStatusErrorGeneric: "Errore durante il caricamento dello stato della serratura",
    credentialsRequired: "Devi inserire un nome utente e una password, oppure avere delle credenziali salvate.",
    connectionOk:
      "Connessione riuscita. {count} dispositivo trovato. | Connessione riuscita. {count} dispositivi trovati.",
    testError: "Errore durante la verifica della connessione",
    credentialsSaved: "Credenziali salvate correttamente",
    saveCredentialsError: "Errore durante il salvataggio delle credenziali",
    saveCredentialsErrorDetail: "Errore durante il salvataggio delle credenziali: {msg}",
    selectAtLeastOne: "Devi selezionare almeno un dispositivo per questa struttura.",
    devicesSaved: "Dispositivi salvati per questa struttura",
    devicesSaveError: "Impossibile salvare i dispositivi",
    saveErrorDetail: "Errore durante il salvataggio: {msg}",
    unitRequired: "Seleziona l'unità per le serrature assegnate come 'Porta dell'appartamento'.",
    bindingsSaved: "Assegnazione salvata correttamente",
    bindingsSaveError: "Impossibile salvare l'assegnazione",
    bindingsSaveErrorDetail: "Errore durante il salvataggio dell'assegnazione: {msg}",
    assignFirst: "Assegna prima la serratura (porta principale o unità) e salva per abilitare il controllo.",
    passcodeNameRequired: "Devi fornire un nome/etichetta per il codice di accesso.",
    passcodeDatesRequired: "Devi indicare una data di inizio e una di fine validità.",
    passcodeCreated: "Codice di accesso creato: {code}",
    passcodeCreateError: "Impossibile creare il codice di accesso",
    passcodeCreateErrorGeneric: "Errore durante la creazione del codice di accesso",
    lockLocked: "Serratura bloccata",
    lockLockError: "Impossibile bloccare",
    lockLockErrorGeneric: "Errore durante il blocco",
    lockUnlocked: "Serratura sbloccata",
    lockUnlockError: "Impossibile sbloccare",
    lockUnlockErrorGeneric: "Errore durante lo sblocco",
    revokeNoProviderId: "Questo codice di accesso non ha un provider_passcode_id. Non può essere revocato in TTLock.",
    revokedOk: "Codice di accesso revocato completamente",
    revokeError: "Impossibile revocare",
    revokeErrorGeneric: "Errore durante la revoca del codice di accesso",
    historyLoadError: "Impossibile caricare la cronologia",
    historyLoadErrorGeneric: "Errore durante il caricamento della cronologia",
  },
};
